import { t } from 'i18next';
import { HeadCell } from './invoicesTable.types';

const basicHeadCells: HeadCell[] = [
  {
    id: 'saleDate',
    numeric: true,
    label: t('saleDate', { ns: 'invoice' }),
    align: 'left',
  },
  {
    id: 'issueDate',
    numeric: true,
    label: t('issueDate', { ns: 'invoice' }),
    align: 'left',
  },
  {
    id: 'dueDate',
    numeric: true,
    label: t('dueDate', { ns: 'invoice' }),
    align: 'left',
  },
  {
    id: 'grossValue',
    numeric: true,
    label: t('grossAmount', { ns: 'priceItem' }),
    align: 'right',
  },
  {
    id: 'displayedStatus',
    numeric: true,
    label: t('invoice.status.label', { ns: 'reports' }),
    align: 'justify',
  },
  // { TEMPORARILY DISABLED - until further development in regards of KSeF
  //   id: 'ksefNumber',
  //   numeric: false,
  //   label: t('invoice.ksefNumber', { ns: 'reports' }),
  // },
];

export const ownHeadCells: HeadCell[] = [
  {
    id: 'code',
    numeric: false,
    label: t('code', { ns: 'invoice' }),
  },
  {
    id: 'jobCode',
    numeric: true,
    label: t('invoice.jobCode', { ns: 'reports' }),
  },
  {
    id: 'client',
    numeric: true,
    label: t('invoice.counterparty', { ns: 'reports' }),
  },
  ...basicHeadCells,
];

export const foreignHeadCells: HeadCell[] = [
  {
    id: 'code',
    numeric: false,
    label: t('code', { ns: 'invoice' }),
  },
  {
    id: 'logNumber',
    numeric: true,
    label: t('logNumber', { ns: 'invoice' }),
  },
  {
    id: 'sellerCounterpartyName',
    numeric: true,
    label: t('issuer', { ns: 'invoice' }),
  },
  ...basicHeadCells,
];

export const administrativeHeadCells: HeadCell[] = [
  {
    id: 'code',
    numeric: false,
    label: t('code', { ns: 'invoice' }),
  },
  {
    id: 'client',
    numeric: true,
    label: t('invoice.counterparty', { ns: 'reports' }),
  },
  ...basicHeadCells,
];

export const allocationProgress = {
  INITIAL: t('allocationProgress.INITIAL', { ns: 'invoice' }),
  PARTIAL: t('allocationProgress.PARTIAL', { ns: 'invoice' }),
  FULL: t('allocationProgress.FULL', { ns: 'invoice' }),
  ACCEPTED: t('allocationProgress.ACCEPTED', { ns: 'invoice' }),
  FINALIZED: t('allocationProgress.FINALIZED', { ns: 'invoice' }),
  CANCELLED: t('allocationProgress.CANCELLED', { ns: 'invoice' }),
  COMPLAINED: t('allocationProgress.COMPLAINED', { ns: 'invoice' }),
};

export const invoiceStatus = {
  PAID: t('invoiceStatus.PAID', { ns: 'invoice' }),
  NOT_PAID: t('invoiceStatus.NOT_PAID', { ns: 'invoice' }),
};
